module.exports = __webpack_public_path__ + "media/landing_page/lp4-hero-mobile-03-6971d5b3.webp";